import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { SELECT_EXPORT_PAGES } from "@/Constants/common";
import {
  deSelectAllListings,
  fetchUpcomingShifts,
  fetchWorkHistory,
  setLoading,
  toggleCandidateUpcomingFilter,
  toggleCandidateWorkedFilter,
  toggleUpcomingShiftsSelectAll,
  toggleWorkedHistorySelectAll,
  updateActiveDetailListing,
  updateSelectedUpcomingShifts,
  updateSelectedWorkedHistory,
  updateToggleListingSelection,
  updateUpComingShiftFilters,
  updateUpComingShiftPagination,
  updateUpComingShiftsView,
  updateWorkedHistoryFilters,
  updateWorkedHistoryPagination,
  updateWorkedHistoryView,
  setShowProfile,
} from "@/reducers/clientcandidatedetail";
import { toastMessageText } from "@/utilities/CommonText";

import BasicInfo from "./BasicInfo";
import ComplianceListingTop from "./ComplianceListingTop";
import DetailSectionTabs from "./DetailSectionTabs";
import FilterModal from "./FilterModal";
import CandidateFullProfileInformation from "./Listing/CandidateFullProfileInformation";
import ComplianceListing from "./Listing/ComplianceListing";
import UpcomingShiftsListing from "./Listing/UpcomingShiftsListing";
import WorkHistoryListing from "./Listing/WorkHistoryListing";
import WorkedFilterModal from "./WorkedFilterModal";
import {
  _exportCandidateUpcomingBooking,
  _exportCandidateWorkedHistory,
} from "../../../../services/clientexport";
import { showSuccessToast } from "../../../../utilities/utils";
import ExportButton from "../ActionButtons/ExportButton";
import { SelectedCountText } from "../candidates/Listing/common/SelectedCountText";
import SwitchListView from "../candidates/Listing/common/SwitchListView";
import TableSearch from "../dataTables/TableSearch";
import FilterButton from "../ListingFilters/FilterButton";

/**
 * Function that renders the right section of the candidate detail page.
 *
 * @return {JSX.Element} The JSX element representing the right section of the candidate detail page.
 */
const CandidateDetailRight = () => {
  const dispatch = useDispatch();
  const {
    workedHistoryView,
    upcomingShiftView,
    activeDetailListing,
    showProfile,
    upComingShiftFilters,
    workedHistoryFilters,
    upComingShiftPagination,
    workedHistoryPagination,
    totalUpcomingShifts,
    isUpcomingShiftSelectedAll,
    candidateUpComingShifts,
    selectedUpComingShifts,
    toggleListingSelection,
    totalWorkedHistory,
    isWorkedHistorySelectedAll,
    selectedWorkedHistory,
    candidateWorkedHistory,
    candidateDetails,
    shiftCompletedCount,
  } = useSelector((state) => state.clientCandidateDetail);

  const { clientUserAllPermissions } = useSelector((state) => state.session);
  // const filterApplied = getIsFilterApplied(_filters);
  const upcomingfilterApplied = Object.values(upComingShiftFilters).some(
    (item) =>
      item !== "" &&
      item !== null &&
      (Array.isArray(item) ? item.length > 0 : true),
  );

  const workedHistoryfilterApplied = Object.values(workedHistoryFilters).some(
    (item) =>
      item !== "" &&
      item !== null &&
      (Array.isArray(item) ? item.length > 0 : true),
  );

  const [updateWorkedHistoryData, setUpdateWorkedHistoryData] = useState(false);
  const [updateUpcomingShiftData, setUpdateUpcomingShiftData] = useState(false);
  // useEffect(()=>{
  //   setUpdateData(!updateData);
  // },[isSelectedAll,selectedApplication])

  useEffect(() => {
    setUpdateWorkedHistoryData(!updateWorkedHistoryData);
  }, [isWorkedHistorySelectedAll, selectedWorkedHistory]);

  useEffect(() => {
    setUpdateUpcomingShiftData(!updateUpcomingShiftData);
  }, [isUpcomingShiftSelectedAll, selectedUpComingShifts]);

  const handleUpComingShiftSearch = (e) => {
    dispatch(deSelectAllListings());
    dispatch(updateUpComingShiftFilters({ search: e.target.value }));
  };
  const handleWorkedHistorySearch = (e) => {
    dispatch(deSelectAllListings());
    dispatch(updateWorkedHistoryFilters({ search: e.target.value }));
  };
  // const [activeTab, setActiveTab] = useState();
  // const [activeTabTop, setActiveTabTop] = useState();

  const resetPaginations = () => {
    dispatch(updateUpComingShiftsView("shifts"));
    dispatch(updateWorkedHistoryView("shifts"));
    dispatch(
      updateUpComingShiftPagination({
        ...upComingShiftPagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(
      updateWorkedHistoryPagination({
        ...workedHistoryPagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(setLoading(true));
    dispatch(updateUpComingShiftFilters({}));
    dispatch(updateWorkedHistoryFilters({}));
  };

  useEffect(() => {
    // if i refresh the page then it will go to the active tab of the page not the candidate profile.
    const savedActiveDetailListing =
      localStorage.getItem("activeDetailListing") || "canProfileInfo";
    const hasDownloadedDocument = localStorage.getItem("downloadedDocument");

    if (hasDownloadedDocument) {
      dispatch(setShowProfile(true));
      dispatch(updateActiveDetailListing("compliance"));
      setTimeout(() => {
        showSuccessToast(toastMessageText.downloadDocumentInDownloadSection);
      }, 1000);
      localStorage.removeItem("downloadedDocument");
    } else {
      dispatch(setShowProfile(savedActiveDetailListing !== "canProfileInfo"));
      dispatch(updateActiveDetailListing(savedActiveDetailListing));
    }

    resetPaginations();

    return () => {
      // Reset tab to "canProfileInfo" on route change
      dispatch(setShowProfile(false));
      dispatch(updateActiveDetailListing("canProfileInfo"));
      localStorage.setItem("activeDetailListing", "canProfileInfo");
    };
  }, []);

  useEffect(() => {
    if (activeDetailListing) {
      localStorage.setItem("activeDetailListing", activeDetailListing);
    }

    dispatch(deSelectAllListings());
    resetPaginations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeDetailListing]);

  const firstRenderForUpComingShift = useRef(true);
  useEffect(() => {
    if (firstRenderForUpComingShift.current) {
      firstRenderForUpComingShift.current = false;
      return;
    }
    dispatch(
      updateUpComingShiftPagination({
        ...upComingShiftPagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(fetchUpcomingShifts());
  }, [upcomingShiftView]);

  const firstRenderForWorkedHistory = useRef(true);
  useEffect(() => {
    if (firstRenderForWorkedHistory.current) {
      firstRenderForWorkedHistory.current = false;
      return;
    }
    dispatch(
      updateWorkedHistoryPagination({
        ...workedHistoryPagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(fetchWorkHistory());
  }, [workedHistoryView]);
  return (
    <div
      className={`CandidateDetailRight_Wrapper transition-linear relative order-1 min-w-0 grow rounded-lg bg-white p-2 md:p-4 lg:order-2`}
    >
      <div className="flex h-full flex-col">
        <div className="mb-[24px] flex items-start gap-4">
          <div className={`${showProfile ? "hidden" : "block"}`}>
            <BasicInfo profileShown={false} />
          </div>
          <div
            className={`${activeDetailListing == "canProfileInfo" ? "min-h-[50px]" : "md:min-h-[132px]"} min-w-0 grow`}
          >
            <DetailSectionTabs />
            {activeDetailListing !== "canProfileInfo" ? (
              <div className="flex min-h-[66px] items-center justify-end border-b border-b-lightblue py-3 md:py-0">
                {activeDetailListing === "upcomingShifts" && (
                  <>
                    <div className="flex w-full flex-col gap-3 md:flex-row md:justify-between">
                      <div className="my-2 flex flex-wrap gap-2 md:flex-nowrap md:gap-[20px]">
                        {/* {upcomingShiftView === "shifts" ? ( */}
                        <div className="flex h-[40px] cursor-pointer overflow-hidden rounded-lg bg-grey [&>*:last-child]:border-r-0 [&>*]:grid [&>*]:w-[56px] [&>*]:place-items-center [&>*]:border-0 [&>*]:border-r [&>*]:border-r-[#E5E6E9] [&>*]:text-txtColor">
                          <ExportButton
                            page={SELECT_EXPORT_PAGES.BOOKED}
                            // exportUrl={
                            //   routingConstants.exportCandiateUpcomingBookings
                            // }
                            exportFunction={_exportCandidateUpcomingBooking}
                            selectedTablesData={selectedUpComingShifts}
                            updateData={updateUpcomingShiftData}
                            ignoreIds={
                              isUpcomingShiftSelectedAll
                                ? candidateUpComingShifts
                                    .filter(
                                      (ele) =>
                                        !selectedUpComingShifts.includes(
                                          ele.contract_id,
                                        ),
                                    )
                                    .map((ele) => ele.contract_id)
                                    .join(",")
                                : ""
                            }
                            isSelectedAll={isUpcomingShiftSelectedAll}
                            extraObj={{
                              contract_ids: selectedUpComingShifts.join(","),
                              candidate_id: candidateDetails.candidate_id,
                            }}
                            emptyExportMessage={
                              toastMessageText.emptyExportMessageForContract
                            }
                          />
                        </div>
                        {/* ) : null} */}

                        <SelectedCountText
                          selectedCount={selectedUpComingShifts.length}
                          totalCount={totalUpcomingShifts}
                          isSelectedAll={isUpcomingShiftSelectedAll}
                          clearSelected={() => {
                            dispatch(
                              updateToggleListingSelection(
                                !toggleListingSelection,
                              ),
                            );
                          }}
                          handleSelectAll={(val) => {
                            dispatch(toggleUpcomingShiftsSelectAll(val));
                          }}
                          updateSelected={(val) => {
                            dispatch(updateSelectedUpcomingShifts(val));
                          }}
                          currentDataLength={candidateUpComingShifts.length}
                        />
                      </div>
                      <div className="my-2 flex flex-wrap gap-2 md:flex-nowrap md:gap-[20px]">
                        <SwitchListView
                          value={upcomingShiftView}
                          handleClick={(value) => {
                            dispatch(deSelectAllListings());
                            dispatch(updateUpComingShiftsView(value));
                          }}
                        />
                        <TableSearch
                          val={upComingShiftFilters.search}
                          handleChange={handleUpComingShiftSearch}
                        />
                        <FilterButton
                          filterApplied={upcomingfilterApplied}
                          handleClick={() => {
                            dispatch(toggleCandidateUpcomingFilter(true));
                          }}
                        />
                        <FilterModal />
                      </div>
                    </div>
                  </>
                )}
                {activeDetailListing === "workHistory" && (
                  <>
                    <div className="flex w-full flex-col gap-3 md:flex-row md:justify-between">
                      <div className="my-2 flex flex-wrap gap-2 md:flex-nowrap md:gap-[20px]">
                        {/* {workedHistoryView === "shifts" ? ( */}
                        <div className="flex h-[40px] cursor-pointer overflow-hidden rounded-lg bg-grey [&>*:last-child]:border-r-0 [&>*]:grid [&>*]:w-[56px] [&>*]:place-items-center [&>*]:border-0 [&>*]:border-r [&>*]:border-r-[#E5E6E9] [&>*]:text-txtColor">
                          <ExportButton
                            page={SELECT_EXPORT_PAGES.WORKED}
                            // exportUrl={
                            //   routingConstants.exportCandidateWorkHistory
                            // }
                            exportFunction={_exportCandidateWorkedHistory}
                            selectedTablesData={selectedWorkedHistory}
                            updateData={updateWorkedHistoryData}
                            ignoreIds={
                              isWorkedHistorySelectedAll
                                ? candidateWorkedHistory
                                    .filter(
                                      (ele) =>
                                        !selectedWorkedHistory.includes(
                                          ele.contract_id,
                                        ),
                                    )
                                    .map((ele) => ele.contract_id)
                                    .join(",")
                                : ""
                            }
                            isSelectedAll={isWorkedHistorySelectedAll}
                            extraObj={{
                              contract_ids: selectedWorkedHistory.join(","),
                              candidate_id: candidateDetails.candidate_id,
                            }}
                            emptyExportMessage={
                              toastMessageText.emptyExportMessageForContract
                            }
                          />
                        </div>
                        {/* ) : null} */}
                        <SelectedCountText
                          selectedCount={selectedWorkedHistory.length}
                          totalCount={totalWorkedHistory}
                          isSelectedAll={isWorkedHistorySelectedAll}
                          clearSelected={() => {
                            dispatch(deSelectAllListings());
                            dispatch(
                              updateToggleListingSelection(
                                !toggleListingSelection,
                              ),
                            );
                          }}
                          handleSelectAll={(val) => {
                            dispatch(toggleWorkedHistorySelectAll(val));
                          }}
                          updateSelected={(val) => {
                            dispatch(updateSelectedWorkedHistory(val));
                          }}
                          currentDataLength={candidateWorkedHistory.length}
                        />
                      </div>
                      <div className="my-2 flex flex-wrap gap-2 md:flex-nowrap md:gap-[20px]">
                        <div className="flex w-full !items-center gap-1 overflow-x-auto">
                          <span
                            className={`text-sm font-bold leading-[normal] text-primary`}
                          >
                            {shiftCompletedCount || "0"}
                          </span>
                          <span className="text-sm font-medium leading-[normal] text-black">
                            {workedHistoryView === "contracts"
                              ? "Contracts completed"
                              : "Shifts completed"}
                          </span>
                        </div>
                        <SwitchListView
                          value={workedHistoryView}
                          handleClick={(value) => {
                            dispatch(deSelectAllListings());
                            dispatch(updateWorkedHistoryView(value));
                          }}
                        />
                        <TableSearch
                          val={workedHistoryFilters.search}
                          handleChange={handleWorkedHistorySearch}
                        />
                        <FilterButton
                          filterApplied={workedHistoryfilterApplied}
                          handleClick={() => {
                            dispatch(toggleCandidateWorkedFilter(true));
                          }}
                        />
                        <WorkedFilterModal />
                      </div>
                    </div>
                  </>
                )}
                {activeDetailListing === "compliance" && (
                  <ComplianceListingTop />
                )}
              </div>
            ) : null}
          </div>
        </div>
        {activeDetailListing === "canProfileInfo" && (
          <CandidateFullProfileInformation />
        )}
        {activeDetailListing === "upcomingShifts" && <UpcomingShiftsListing />}
        {activeDetailListing === "workHistory" && <WorkHistoryListing />}
        {activeDetailListing === "compliance" && <ComplianceListing />}
      </div>
    </div>
  );
};

export default CandidateDetailRight;
